import ovenOpen from "../../assets/games/picnic-game/appliances/oven-open.png";
import ovenClosed from "../../assets/games/picnic-game/appliances/oven-closed.png";
import ovenBaking from "../../assets/games/picnic-game/appliances/oven-baking.png";
import pastaPan from "../../assets/games/picnic-game/appliances/pasta-pan.png";
import stove from "../../assets/games/picnic-game/appliances/stove.png";
import pastaCooking from "../../assets/games/picnic-game/appliances/pasta-cooking.png";
import grillerOpen from "../../assets/games/picnic-game/appliances/griller-open.png";
import grillerClosed from "../../assets/games/picnic-game/appliances/griller-closed.png";
import grillerGrilling from "../../assets/games/picnic-game/appliances/griller-grilling.png";
import blender from "../../assets/games/picnic-game/appliances/blender.png";
import blenderBlending from "../../assets/games/picnic-game/appliances/blender-blending.png";
import blenderMachine from "../../assets/games/picnic-game/appliances/blender-machine.png";

const picnicAppliancesImagesObj = {
  ovenOpen,
  ovenClosed,
  ovenBaking,
  pastaPan,
  stove,
  pastaCooking,
  grillerOpen,
  grillerClosed,
  grillerGrilling,
  blender,
  blenderBlending,
  blenderMachine,
};

export default picnicAppliancesImagesObj;
